"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cornovecchio": {
    "dbc4c9ae": [{
      "hkey": "810aca98",
      "slug": "cornovecchio",
      "name": "Cornovecchio",
      "primary": true,
      "skipSearch": false
    }],
    "campagnola": [{
      "hkey": "810aca98",
      "slug": "cornovecchio",
      "name": "Cornovecchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "097eb8e7": [{
      "hkey": "810aca98",
      "slug": "cornovecchio",
      "name": "Cornovecchio",
      "primary": true,
      "skipSearch": false
    }],
    "cascine-lardera": [{
      "hkey": "810aca98",
      "slug": "cornovecchio",
      "name": "Cornovecchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1450d346": [{
      "hkey": "5c3250e9",
      "slug": "moriane-castellina",
      "name": "Moriane-Castellina",
      "primary": true,
      "skipSearch": false
    }],
    "castellina": [{
      "hkey": "5c3250e9",
      "slug": "moriane-castellina",
      "name": "Moriane-Castellina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cornovecchio"
    }],
    "f73d2973": [{
      "hkey": "810aca98",
      "slug": "cornovecchio",
      "name": "Cornovecchio",
      "primary": true,
      "skipSearch": false
    }],
    "fontane": [{
      "hkey": "810aca98",
      "slug": "cornovecchio",
      "name": "Cornovecchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fec87148": [{
      "hkey": "810aca98",
      "slug": "cornovecchio",
      "name": "Cornovecchio",
      "primary": true,
      "skipSearch": false
    }],
    "goretti": [{
      "hkey": "810aca98",
      "slug": "cornovecchio",
      "name": "Cornovecchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c387dd1": [{
      "hkey": "5c3250e9",
      "slug": "moriane-castellina",
      "name": "Moriane-Castellina",
      "primary": true,
      "skipSearch": false
    }],
    "moriane-alte": [{
      "hkey": "5c3250e9",
      "slug": "moriane-castellina",
      "name": "Moriane-Castellina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "43f44a0e": [{
      "hkey": "5c3250e9",
      "slug": "moriane-castellina",
      "name": "Moriane-Castellina",
      "primary": true,
      "skipSearch": false
    }],
    "moriane-basse": [{
      "hkey": "5c3250e9",
      "slug": "moriane-castellina",
      "name": "Moriane-Castellina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cornovecchio"
    }]
  }
};
exports["default"] = _default;